import type { UserHydraItem } from "@verbleif/lib/src/composables/Api/Type/User/user.interface";
import type { UserPreferencesHydraItem } from "@verbleif/lib/src/composables/Api/Type/UserPreferences/user_preferences.interface";
import type { AuthResponse } from "@verbleif/shared/src/composables/Authentication/Interface/AuthResponse.interface";
import router from "@cms/core/plugin/router";
import * as Sentry from "@sentry/vue";
import { fetchCurrentUserWithFreshToken } from "@verbleif/shared/src/composables/AuthStore/currentUser.api";
import { useAuthStore } from "@verbleif/shared/src/composables/AuthStore/useAuthStore";
import { useClientSettingsStore } from "@verbleif/shared/src/composables/ClientSettingsStore/useClientSettingsStore";
import { permissionService } from "@verbleif/shared/src/composables/Permissions/SharedPermissions";
import { fetchResource } from "@verbleif/shared/src/composables/Query/resourceQuery";

type CurrentUser = UserHydraItem & {
  gleapUserHash: string
};

const authStore = useAuthStore();

/** Stores a new token pair; the refresh plugin calls it before anything waits on the new tokens. */
export function storeTokens(response: AuthResponse): void {
  authStore.setToken(response.access_token);
  authStore.setRefreshToken(response.refresh_token);
}

export async function onAuthenticateSuccess(response: AuthResponse, isLogin: boolean = false): Promise<void> {
  storeTokens(response);

  // The pair was just issued: a refused token is an outage, not a reason to refresh again (that would wait on itself).
  const user = await fetchCurrentUserWithFreshToken<CurrentUser>();

  authStore.setUser(user);

  const userPreferences = await fetchResource<UserPreferencesHydraItem>("/api/user_preferences/me");
  authStore.setUserPreferences(userPreferences);

  permissionService.init();

  await useClientSettingsStore().load();

  if (import.meta.env.PROD) {
    Sentry.setUser(user);
  }
  const { returnUrl } = useAuthStore();
  if (isLogin) {
    // await nextTick();
    // if (!isAdmin.value) {
    //   await router.push({ name: "404" });
    //   return;
    // }

    if (!returnUrl.value) {
      await router.push({ name: "client-overview" });
    } else {
      await router.push(returnUrl.value);
      returnUrl.value = null;
    }
  }
}
